module.exports = __webpack_public_path__ + "static/plus-icon.7ffd42c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plus-icon.svg
// module id = 768
// module chunks = 213346868834355 247189622667744